
<div
  :class="classes(n(), { [n('--disabled')]: disabled })"
  role="group"
  :aria-disabled="disabled ? 'true' : undefined"
  @touchstart="onTouchStart"
  @touchmove="onTouchMove"
  @touchend="onTouchEnd"
  @touchcancel="onTouchEnd"
>
  <div
    :class="n('content')"
    :style="contentStyle"
    @click="handleContentClick"
  >
    <slot />
  </div>

  <div
    v-if="actions.length"
    ref="actionsRef"
    :class="n('actions')"
    :style="actionsStyle"
  >
    <div
      v-for="(action, index) in actions"
      :key="action.key"
      role="button"
      :class="
        classes(
          n('action'),
          n(`action--${action.layout || 'text'}`),
          isPresetColor(action) ? n(`action--${action.color || 'blue'}`) : ''
        )
      "
      :style="actionStyle(action, index)"
      :aria-label="getAriaLabel(action)"
      @click="handleActionClick(action, index)"
    >
      <div :class="n('action-inner')" :style="actionInnerStyle">
        <component
          :is="action.icon"
          v-if="action.icon && action.layout !== 'text'"
          :class="n('action-icon')"
          :width="ACTION_ICON_SIZE"
          :height="ACTION_ICON_SIZE"
          :color="ACTION_ICON_COLOR"
        />
        <span
          v-if="showText(action)"
          :class="n('action-text')"
          aria-live="polite"
        >
          {{ actionText(action) }}
        </span>
      </div>
    </div>
  </div>
</div>
